export default "__VITE_ASSET__C7Qn59mX__"